// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"bx_-7CWVST","header":"_2AR-JgWtP4","content":"_13tn9mZoiZ"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Account/Panel/Panel.module.less
// module id = 972
// module chunks = 3